import { forwardRef } from 'react';
import TableBaseButton from './TableBaseButton';

interface SubmitButtonProps {
  onClick: () => void;
  ref?: React.Ref<HTMLButtonElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const SubmitButton = forwardRef<HTMLButtonElement, SubmitButtonProps>(
  ({ onClick, onKeyDown }, ref) => {
    return (
      <TableBaseButton
        onClick={onClick}
        variant="primary"
        buttonText="保存"
        ref={ref}
        onKeyDown={onKeyDown}
      />
    );
  }
);

SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;
